import { forwardRef, type Ref, type SVGProps } from "react";
const IconPanorama360OutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M9.91 17.3A1.91 1.91 0 1 1 8 15.4a1.92 1.92 0 0 1 1.91 1.9" />
    <path d="M29.81 8.51A4.36 4.36 0 0 0 28 6.73a15 15 0 0 0-3.63-1.43l-1.14-.28a1.01 1.01 0 0 0-1.2.77A1 1 0 0 0 22 6v5.82a31 31 0 0 1-3.24.38l-.17.01-.97.05a29 29 0 0 1-3.24 0l-.97-.05-.17-.01a30 30 0 0 1-3.24-.41V6a1.01 1.01 0 0 0-1.02-1 1 1 0 0 0-.21.02l-1.14.28A15 15 0 0 0 4 6.73a4.36 4.36 0 0 0-1.81 1.78A2 2 0 0 0 2 9.3v14.6a1 1 0 0 0 .32.74 11.2 11.2 0 0 0 3.82 2.18 20 20 0 0 0 2.17.65 31.8 31.8 0 0 0 7.69.83 28.5 28.5 0 0 0 9.86-1.48c.46-.16 1.27-.53 1.28-.53a10.2 10.2 0 0 0 2.1-1.27c.04-.02.44-.38.45-.39a1 1 0 0 0 .31-.73V9.3a2 2 0 0 0-.19-.79M24 7.27c2.45.68 3.8 1.55 3.99 2.03-.19.48-1.54 1.35-3.99 2.03zm-16 0v4.06c-2.45-.68-3.8-1.55-3.99-2.03C4.2 8.82 5.55 7.95 8 7.27m8 19.03a32 32 0 0 1-6.01-.51l6.01-6 2.29 2.3 1 1a1 1 0 1 0 1.42-1.43l-.3-.29L23 18.78l4.81 4.81c-1.27.92-4.65 2.71-11.81 2.71m12-5.34-4.29-4.3a1 1 0 0 0-.7-.29 1.3 1.3 0 0 0-.19.02.92.92 0 0 0-.5.25l-.03.02-3.29 3.3-2.29-2.3a1 1 0 0 0-1.42 0l-7.57 7.58A11.6 11.6 0 0 1 4 23.45V11.87a15.1 15.1 0 0 0 4 1.53 36 36 0 0 0 5.16.8l1.18.06a44 44 0 0 0 3.32 0l1.18-.06a36 36 0 0 0 5.16-.8 15.1 15.1 0 0 0 4-1.53z" />
  </svg>
);
const ForwardRef = forwardRef(IconPanorama360OutlineSVG);
ForwardRef.displayName = "IconPanorama360Outline";
export { ForwardRef as IconPanorama360Outline };
